module.exports = __webpack_public_path__ + "static/media/Kosar.a48ee5cf.svg";